// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"26a7d540","363":"96f4349a","453":"ce1ca6f3","525":"1b19a35e","605":"6747fb4b","634":"8f32c65b","990":"184f6bad"}[chunkId] + ".chunk.js";
};